module.exports = __webpack_public_path__ + "img/banner-second.07f73e1a.jpg";